/**
 * How much of a listing the panel asks for.
 *
 * Every admin listing in the BFF defaults to **10 items**, and every screen here groups the whole
 * result by BU — so a default request silently showed a slice and called it the total. That is how
 * a page that existed became invisible and its creation failed with "slug already exists".
 *
 * @module Shared/constants
 */

/** The largest page the BFF accepts on its admin listings. */
export const MAX_LIST_LIMIT = 100;

/**
 * Whether the server has more rows than were received.
 *
 * Asking for the maximum is not a fix, it is a bigger slice: past {@link MAX_LIST_LIMIT} the
 * screen would truncate again. So screens say so instead of pretending the list is complete.
 *
 * @param total - What the server reports it has.
 * @param shown - How many rows arrived.
 */
export function isListTruncated(total: number | undefined, shown: number): boolean {
  if (total === undefined) return false;
  return total > shown;
}
